<template>
  <div class="sales-panel container-fluid h-100 w-100">
    <div v-if="showHeader" class="container d-flex float-row align-items-center sale-header">
      <a class="btn fw-bold text-primary" @click="selectCustomer">Add Customer</a>
      <span class="badge bg-info m-2" v-if="tipAmount > 0">Tip : {{ $utils.formatMoney(tipAmount) }}</span>
    </div>

    <b class="m-2" v-if="customer">Customer : {{ customer }}</b>

    <div class="sale-lines-table">
      <ul class="sales-list">
        <li :key="sale.id || sale.index || `${sale.Plu}-${sale.Description}-${index}`" v-for="(sale , index) in currentSaleLines">
          <CurrentSaleLine :sale-line="sale"/>
        </li>
      </ul>
    </div>
    <div class="sale-stats">
      <SaleDetails/>
    </div>

    <!-- Offline Create Customer Modal -->
    <custom-modal ref="offlineCustomerModal" title="Create Customer (Offline)" :is-form="true" @submit="submitOfflineCustomer">
      <div class="form-floating mb-2">
        <input type="text" class="form-control" id="offline_name" v-model="offlineCustomerForm.Name" placeholder="Customer Name" required>
        <label for="offline_name">Customer Name</label>
      </div>
      <div class="form-floating mb-2">
        <input type="tel" class="form-control" id="offline_contact" v-model="offlineCustomerForm.CellNumber" placeholder="Contact No." required>
        <label for="offline_contact">Contact No.</label>
      </div>
      <div class="form-floating mb-2">
        <input type="text" class="form-control" id="offline_surname" v-model="offlineCustomerForm.Surname" placeholder="Surname (optional)">
        <label for="offline_surname">Surname (optional)</label>
      </div>
      <div class="form-floating mb-2">
        <input type="text" class="form-control" id="offline_address" v-model="offlineCustomerForm.Adress1" placeholder="Address (optional)">
        <label for="offline_address">Address (optional)</label>
      </div>
    </custom-modal>
  </div>
</template>

<script>
import CurrentSaleLine from "@/components/point-of-sale/sales/CurrentSaleLine";
import SaleDetails from "@/components/point-of-sale/sales/SaleDetails";
import CustomModal from "@/components/layout/utils/CustomModal";
import connectivityMonitor from "@/services/connectivityMonitor";
import { responses } from "@/utils/responses";
import { errorHandler } from "@/services/errorHandler";

export default {
  name: "CurrentSaleTable",
  components: {SaleDetails, CurrentSaleLine, CustomModal},
  props: {
    showHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    showBack: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    currentSale() {
      return this.$store.getters.getCurrentSale
    },
    tipAmount(){
      let tipAmount = this.$store.getters.getTipAmount;
      return tipAmount;
    },

    customer() {
      let id = this.$store.getters.getCustomer;
      return this.$store.getters.getDebtorByID(id);
    },
    currentSaleLines() {
      return this.$store.getters.getSaleLines
    }
  },
  data() {
    return {
      isOnline: true,
      unsubscribeOnline: null,
      unsubscribeOffline: null,
      offlineCustomerForm: { Name: '', CellNumber: '', Surname: '', Adress1: '', Area: '', vat: '' },
    };
  },
  mounted() {
    this.isOnline = connectivityMonitor.getStatus();
    this.unsubscribeOnline = connectivityMonitor.subscribe('online', () => {
      this.isOnline = true;
    });
    this.unsubscribeOffline = connectivityMonitor.subscribe('offline', () => {
      this.isOnline = false;
    });
  },
  beforeDestroy() {
    if (this.unsubscribeOnline) this.unsubscribeOnline();
    if (this.unsubscribeOffline) this.unsubscribeOffline();
  },
  methods: {
    selectCustomer(){
      const isOnline = connectivityMonitor.getStatus();
      if (isOnline) {
        return this.$router.push({ name : `select-customer` , query : { saleNumber : this.$route.query.saleNumber } })
      }
      if (this.$refs.offlineCustomerModal) {
        this.offlineCustomerForm = { Name: '', CellNumber: '', Surname: '', Adress1: '', Area: '', vat: '' };
        this.$refs.offlineCustomerModal.openModal();
      }
    },
    async submitOfflineCustomer() {
      try {
        if (!this.offlineCustomerForm?.Name || !this.offlineCustomerForm?.CellNumber) {
          responses.showWarning('Please provide Name and Contact');
          return;
        }
        this.$utils.showLoading();
        const rec = await this.$store.dispatch('createOfflineDebtor', this.offlineCustomerForm);
        if (rec && rec.Id) {
          this.$store.commit('setCustomer', rec.Id);
          responses.showSuccess('Offline customer added to sale');
          this.offlineCustomerForm = { Name: '', CellNumber: '', Surname: '', Adress1: '', Area: '', vat: '' };
          if (this.$refs.offlineCustomerModal) this.$refs.offlineCustomerModal.closeModal();
        }
      } catch (e) {
        errorHandler.tomcatError(e, false, 'Failed to save offline customer');
      } finally {
        this.$utils.hideLoading();
      }
    },
    close() {
      return this.$router.push({ name :'pos' })
    },

    printBill() {
      this.$utils.showLoading()
      return this.$store.dispatch(`printBillSlip` , this.$route.query.saleNumber)
          .finally(()=>this.$utils.hideLoading())
    },
  }
}
</script>

<style lang="scss" scoped>
.sales-panel {
  display: flex;
  flex-direction: column;
  padding: 0;
  position: relative;
  .sale-header {
    background: #F2F2F4;
    -webkit-box-shadow: 0 2px 8px 0 rgba(203, 153, 126, 0.4);
    box-shadow: 0 2px 8px 0 rgba(203, 153, 126, 0.4);
    border: 1px solid #E6E7EC;
    height: 53px;
    max-height: 55px;

    .header {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;

      h2 {
        margin: 0;
      }

      button {
        width: 30px;
        background: white;
        font-size: 25px;
      }
    }
  }

  @media (min-height: 769px) {
    .sale-lines-table {
      height: 83vh !important;
    }
  }

  .sale-lines-table {
    flex: auto;
    overflow-y: auto;
    overflow-x: hidden;
    height: 77vh;

    .sales-list {
      list-style: none;
      padding: 0 0 130px 0;

      li {
        border: 1px solid #E6E7EC;
      }
    }
  }

  .sale-stats {
    position: absolute;
    background: #F2F2F4;
    border: 1px solid #E6E7EC;
    max-height: 163px;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>
